import { List, Map } from 'immutable';

import * as types from './types';
import { types as teamsTypes } from './../../ducks/teams';

const initialState = new Map({
  loading: true,
  selectedTeams: new List(),
  pagination: new Map({
    currentPage: 1,
  }),
});

const teamsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.UPDATE_OFFSET:
      return state.setIn(['pagination', 'currentPage'], payload);
    case types.TOGGLE_TEAM_SELECTION: {
      const selectionList = state.get('selectedTeams');
      const index = selectionList.indexOf(payload);
      const currentSelection = index === -1 ?
        selectionList.push(payload) :
        selectionList.delete(index);
      return state.set('selectedTeams', currentSelection);
    }
    case teamsTypes.TEAM_REMOVE.SUCCESS: {
      return state.withMutations((mutable) => {
        const selectionList = mutable.get('selectedTeams');
        const index = selectionList.indexOf(payload);
        if (index !== -1) {
          mutable.deleteIn(['selectedTeams', index]);
        }
      });
    }
    case types.INITIAL_TEAM_TABLE.SUCCESS:
      return state.set('loading', false);
    default:
      return state;
  }
};

export default teamsReducer;
